import React from 'react';
import styles from './VgenAdv.module.css';
const vgenUrl = process.env.REACT_APP_VGEN_URL+"?source=yuquerunner"
const VgenAdv = (props) => {
  const { setShowVgenAdv, setVgenAdvDismissed } = props;
  return (
    <div
      className={styles.container}
      onClick={()=> window.open(vgenUrl, "blank")}
    >
      <div className={styles.inner}>
        {/* Header Section */}
        <div className={styles.header}>
          <div className={styles.iconWrapper}>

          </div>
          <h3 className={styles.title}>代码运行成功！</h3>
        </div>

        <div className={styles.divider} />

        {/* Features Section */}
        <div className={styles.featureSection}>

          <h4 className={styles.featureTitle}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
              <path d="M9 18h6"></path>
              <path d="M10 22h4"></path>
            </svg>
            想深入学习吗？
          </h4>
          <p className={styles.featureSubtitle}>Vgen 智慧学伴可以帮你：</p>
          <div className={styles.featureList}>
            <div className={styles.featureItems}>
              <div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                </div>
                <span>生成知识点卡片</span>
              </div>

              <div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M10 9H8"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                  </svg>
                </div>
                <span>智能练习题，巩固理解</span>
              </div>

              <div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z"></path>
                    <path d="m6.2 5.3 3.1 3.9"></path>
                    <path d="m12.4 3.4 3.1 4"></path>
                    <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"></path>
                  </svg>
                </div>
                <span>解析相关视频教程</span>
              </div>

              <div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                  </svg>
                </div>
                <span>AI 一对一答疑</span>
              </div>
            </div>
          </div>
        </div>

        {/* Welfare Section */}
        <div className={styles.welfareSection}>
          <div className={styles.welfareItem}>
            <svg className={styles.blueGift} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="8" width="18" height="4" rx="1"></rect>
              <path d="M12 8v13"></path>
              <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
              <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
            </svg>
            <span className={styles.boldText}>注册送200饼干，可解析120分钟视频</span>
          </div>
          <div className={styles.welfareItem}>
            <svg className={styles.amberGift} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="8" width="18" height="4" rx="1"></rect>
              <path d="M12 8v13"></path>
              <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
              <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
            </svg>
            <span>抽京东卡/B站大会员 + 邀好友赢200元京东E卡</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <button className={styles.exploreBtn}>去 Vgen 探索</button>
          <button className={styles.cancelBtn}
                  onClick={(event)=>{
                    setShowVgenAdv(false);
                    setVgenAdvDismissed(true);
                    event.stopPropagation();
                  }}
          >暂时不用</button>
        </div>

        <span className={styles.footerNote}>
           限时福利，6/15 截止
        </span>
      </div>
    </div>
  );
};

export default VgenAdv;
